import { render } from "./VoiceTranscript.vue?vue&type=template&id=53256382&scoped=true"
import script from "./VoiceTranscript.vue?vue&type=script&lang=js"
export * from "./VoiceTranscript.vue?vue&type=script&lang=js"

import "./VoiceTranscript.vue?vue&type=style&index=0&id=53256382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53256382"]])

export default __exports__